/* RESPONSIBLE TEAM: team-phone */

const TAB_ID_KEY = 'intercom-tab-id';
let cachedId: string | null = null;
let baseId: string | null = null;

export function getTabId(): string {
  if (!cachedId) {
    try {
      baseId = sessionStorage.getItem(TAB_ID_KEY);
    } catch {
      // Storage may be blocked in incognito mode
    }
    if (!baseId) {
      baseId = crypto?.randomUUID?.() ?? `${Date.now()}-${Math.random()}`;
    }
    cachedId = `${baseId}-${performance.now().toFixed(0)}`;
  }
  try {
    sessionStorage.setItem(TAB_ID_KEY, baseId!);
  } catch {
    // Storage may be blocked in incognito mode
  }
  return cachedId;
}
